import { axios, Response } from '../index'

export interface GetClinicTasksResponse {
  id: string
  title: string
  description: string
  companyOrUserEntity: CompanyOrUserEntity
  createdDate: string
  createdBy: PersonaInfoSummary
  checklistsResponses: GetChecklistInFavoriteTaskByIdResponse[]
  taskTags: FavoriteTaskTagResponse[]
}

interface GetChecklistInFavoriteTaskByIdResponse {
  id: string
  taskId: string
  title: string
  checklistItems: GetChecklistItemInFavoriteTaskByIdResponse[]
}

interface GetChecklistItemInFavoriteTaskByIdResponse {
  id: string
  title: string
  checklistId: string
}

interface PersonaInfoSummary {
  userId: string
  username: string
  avatarUrl: string
}

interface FavoriteTaskTagResponse {
  id: number
  title: string
  hexadecimalColorCode: string
}

enum CompanyOrUserEntity {
  COMPANY = 'COMPANY',
  USER = 'USER'
}

const getClinicTasks = (
  loggedPersonaId: string
): Response<GetClinicTasksResponse[]> => {
  return axios.get(`/v1/personas/${loggedPersonaId}/favorites-tasks`)
}

export default getClinicTasks
